import {
  ConjuntosCriterio,
  CreditEngineFormValues,
  CriteriaEnginePT,
  Criterio,
} from "@/models/consignado/criteriaEngine.model";

export const mapCriteriaEngineToPT = (
  data: CreditEngineFormValues
): CriteriaEnginePT => {
  const conjuntosCriterios: ConjuntosCriterio[] = [];

  for (const set of data.criteriaSets) {
    const criterios: Criterio[] = [];

    for (const rule of set.criteriaRules) {
  
      criterios.push({
        ...(rule?.id && { id: rule.id }),
        nome: rule.name || "",
        campo: rule.field,
        operador: rule.operator,
        valor: rule.operator === "NOTIN" ? String(rule.value || "").replace(/\s+/g, "") : String(rule.value || ""),
        ordem: rule.order,
        fonte_dados: rule.dataSource,
      });
    }

    conjuntosCriterios.push({
      ...(set?.id && { id: set.id }),
      nome: set.name,
      descricao: set.description,
      criterios,
    });
  }

  return {
    ...(data?.id && { id: data.id }),
    nome: data.creditEngineName,
    descricao: data.creditEngineDescription,
    conjuntos_criterios: conjuntosCriterios,
  };
};
